import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { PageHeader } from "@/widgets/page-header"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { selectCommunityInfo } from "@/entities/community"
import HistorySvg from '@/shared/assets/images/Bank.svg'
import { useEffect, useRef } from "react"
import { fetchPairChart, fetchPairGlass, selectPair } from "../model"
import { useParams } from "react-router-dom"
import { fetchPair } from "../model"
import { PairGlass } from "./pair-glass"
import { PairChart } from "./pair-chart"
import { CreateBuyOrder } from "./create-buy-order"
import { CreateSellOrder } from "./create-sell-order"

export const SocialMarketPairPage = () => {
    const { id } = useParams()
    const isFirstRender = useRef(true);
    const dispatch = useAppDispatch()
    const pair = useAppSelector(selectPair)
    const community = useAppSelector(selectCommunityInfo)


    useEffect(() => {
        if (!isFirstRender.current && pair.id) {
            dispatch(fetchPairGlass())
            dispatch(fetchPairChart())
        }
    }, [pair])

    useEffect(() => {
        if (id !== pair.id) {
            dispatch(fetchPair(id))
        }
        isFirstRender.current = false
    }, [id])

    return (
        <div className="_page_container flex-1">
            <PageHeader title="Маркет социальных программ" />
            <div className='flexbox h-full '>
                <PageSubtitle title="Операции" />
                <div className="grid grid-cols-12 gap-4 auto-rows-fr">
                    <div className="col-span-7 screen:col-span-8 flex flex-col gap-4">
                        <PairChart />
                        <PairGlass />
                    </div>
                    <div className="col-span-5 screen:col-span-4 flex flex-col gap-4">
                        <div className={'rounded-2xl screen:rounded-3xl overflow-hidden transition-all ease-in bg-white w-full px-4 py-5 screen:px-6 screen:py-7 flex justify-between items-center'}>
                            <div className='flex overflow-hidden items-center gap-3'>
                                <div className={'shrink-0 bg-color-dark transition-all ease-in rounded-full w-[56px] h-[56px] flex items-center justify-center text-color-primary'}>
                                    <div className="fill-color-dark text-color-primary">
                                        <HistorySvg width={32} height={32} />
                                    </div>
                                </div>
                                <div className={'text-color-base w-full overflow-hidden transition-all ease-in'}>
                                    <div className='text-base leading-[16px] screen:text-lg uppercase screen:leading-[25px] mb-2 screen:mb-2'>Партнеры</div>
                                    <div className='text-2xl screen:text-[32px] text-nowrap w-full overflow-hidden overflow-ellipsis leading-[24px] font-mediumttf screen:leading-[32px] font-semibold'>{community.community_name}</div>
                                </div>
                            </div>
                        </div>
                        {community.type === 'foundation'
                            ? <CreateBuyOrder />
                            : <CreateSellOrder />
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}